import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { CustomerAdminService } from "../../services/customer-maintenance/customer-admin.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CustomerModel } from "../../models/customer-maintenance/customer.model";
import { HelpService } from "../../services/help.service";

@Component({
    selector: 'app-upload-file-dialog',
    templateUrl: './upload-file-dialog.component.html',
    styleUrls: ['./upload-file-dialog.component.scss'],
    standalone: false
})
export class UploadFileDialogComponent implements OnInit, OnDestroy {

  expenseCodesFile = new FormControl(null, Validators.required);
  loading = false;

  private uploadExpenseCodeFileSubs: Subscription;

  constructor(
    private readonly dialogRef: MatDialogRef<UploadFileDialogComponent>,
    private readonly customerService: CustomerAdminService,
    private readonly helpService: HelpService,
    @Inject(MAT_DIALOG_DATA) public data: { customer: CustomerModel }
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if(this.uploadExpenseCodeFileSubs) {
      this.uploadExpenseCodeFileSubs.unsubscribe();
    }
  }

  uploadExpenseCodes(): void {
    this.loading = true;
    if(this.expenseCodesFile.valid) {
      const formData = new FormData();
      formData.append('file', this.expenseCodesFile.value[0]);
      this.uploadExpenseCodeFileSubs = this.customerService.uploadExpenseCodes(formData.get('file'), this.data.customer.CustomerID).subscribe({
        next: () => {
          this.loading = false;
          this.helpService.showMessageNotification('Expense Codes uploaded successfully!', 'success');
          this.dialogRef.close(true);
        },
        error: () => {
          this.loading = false;
          this.helpService.showMessageNotification('Error! Please try again.', 'danger');
        }
      });
    }
  }

}
